import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { HomeContainer } from "./style.js";
import Button from "../../components/button";
import { Link } from "react-router-dom";
const Home = () => {
  return (
    <HomeContainer>
      <div className="banner">
        <picture>
          <source media="(max-width:760px)" srcset="/Mitsubishi-Sales.jpg" />
          <img src="/Mitsubishi-Sales.jpg" alt="Mitsubishi" />
        </picture>
      </div>
      <section className="main">
        <Container>
          <Row className="slogan-area">
            <Col sm={12} md={12} lg={3} className="right">
              <span>سـامانه فــــــروش</span>
              <br />
              <span className="small-span">محصولات آرین موتور</span>
            </Col>
            <Col sm={12} md={12} lg={9} className="left">
              <div className="text">
                به سامانه فروش محصولات آرین موتور خوش آمدید. جهت تسریع در فرآیند
                خرید می توانید از قبل نسبت به تکمیل پروفایل خود در قسمت پنل
                کاربری اقدام نمایید.
              </div>
              <div className="buttons">
                <Link to="/sell">
                  <Button title="شروع خرید" btn="primary" />
                </Link>
              </div>
            </Col>
          </Row>
          {/*<Row>*/}
            {/*<Col sm={12} md={12} lg={3}>*/}
            {/*  <img src="/lamari.png" className="car-pic" alt="lamari" />*/}
            {/*</Col>*/}
            {/*<Col sm={12} md={12} lg={9}>*/}
            {/*  <div className="content">*/}
            {/*    <div className="text">*/}
            {/*      خرید خودروی آرین موتور ایما از طریق بورس کالای ایران پیرو اعلامیه*/}
            {/*      عرضه خودروی آرین موتور ایما در بورس کالای ایران،*/}
            {/*      از متقاضیان محترم خواهشمند است ضمن اخذ بورس کالا و*/}
            {/*      تکمیل مراحل ثبت نام نزد کارگزاری های منتخب،*/}
            {/*      نسبت به ثبت سفارش خرید خود اقدام*/}
            {/*      نمایند.*/}
            {/*      <br /> متقاضیان محترم می توانند با مشاهده فیلم آموزشی زیر از*/}
            {/*      کلیه مراحل اخذ بورس کالا و ثبت سفارش از طریق کارگزاری ها مطلع*/}
            {/*      شوند.*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</Col>*/}
          {/*</Row>*/}
          {/*<section className="video">*/}
          {/*  <video controls poster="video_bg.png">*/}
          {/*    <source src="lamari.mp4" type="video/mp4" />*/}
          {/*  </video>*/}
          {/*</section>*/}
        </Container>
      </section>
    </HomeContainer>
  );
};
export default Home;
